// TIZIM ROLINING NOMI — panel tilida (N5).
//
// <h2>Nima o'lchangan (2026-08-15, jonli Staging, tenant `af-isp`)</h2>
//
// Tenantning `locale` = `ru`, ya'ni operator RUSCHA panel ko'radi.
// `/roles` sahifasida esa uchta rol nomi O'ZBEKCHA turardi:
//
//     SUPPORT        -> «Qo'llab-quvvatlash»
//     VENUE_MANAGER  -> «Ob'ekt menejeri»
//     VIEWER         -> «Kuzatuvchi»
//
// Qolgan beshtasi tasodifan xalqaro so'z bo'lgani uchun ko'zga
// tashlanmasdi (`Administrator`, `Moderator`, `Reseller`, `Agent`,
// `Super administrator`) — ya'ni nuqson «uchta rolda» emas, BUTUN
// ro'yxatda: sakkiztasining hammasi bitta tilda qotirilgan.
//
// <h2>⚠️ ILDIZI MIGRATSIYADA — bu yerda faqat KO'RSATISH tuzatiladi</h2>
//
// Nom `identity.seed_system_roles()` da satr sifatida yoziladi
// (`V202608050300__identity_module_permissions.sql`) va `identity.role.name`
// ustunida yashaydi. Bazadagi qiymatni almashtirish IKKI sababga ko'ra
// qilinmadi:
//
//   1. bir ustunda BITTA til bo'ladi — qaysi birini tanlasak ham
//      qolgan ikki panelda o'sha nuqson qoladi. Ustunni uch tilga
//      bo'lish esa `catalog` paketlaridagi JSONB modelini talab
//      qilardi (§30.6/§30.39) va u yerda ham KO'RSATISH yarim
//      qolgan edi;
//   2. nom TAHRIRLANADIGAN maydon: administrator tizim rolini
//      nusxalab, o'z nomini qo'yishi mumkin. Ya'ni ustun umuman
//      «tarjima manbai» emas.
//
// ⚠️ Shuning uchun tarjima FAQAT `system = true` rollarga qo'llanadi.
// Foydalanuvchi yaratgan rolning nomi — uning O'Z matni va uni
// tarjima qilish mumkin emas ham, kerak ham emas.
//
// ⚠️ Noma'lum kod uchun zaxira — bazadagi nom. Yangi tizim roli
// qo'shilib, tarjimasi hali yozilmagan bo'lsa qator BO'SH
// ko'rinmasligi kerak (`jobMessageText` va `reasonText` bilan ayni
// qaror).

import type { Translate } from '@/shared/api/errors'
import uz from '@/app/i18n/uz.json'

const SEEDED_NAMES: Record<string, string> = uz.roles.systemName

export interface NamedRole {
  code: string
  name: string
  system: boolean
}

/**
 * Ro'yxatda va dialoglarda ko'rsatiladigan rol nomi.
 *
 * @param role `code` / `name` / `system` maydonlari bo'lgan har qanday obyekt
 */
export function roleName(role: NamedRole, t: Translate): string {
  // Migratsiya ekkan rol shablonlari (Kassir, Filial rahbari…) `system = false`,
  // lekin nomi o'zgarmagan bo'lsa ular ham tarjima qilinadi
  if (!role.system && SEEDED_NAMES[role.code] !== role.name) return role.name
  return t(`roles.systemName.${role.code}`, { defaultValue: role.name })
}
